export default {
  palette: {
    primary: '#8ee8ff',
    error: '#ff5959',
    errorAlt: '#ff5959',
    success: '#9affa6',
    successAlt: '#59ff67',
    warning: '#ffa359',
    warningAlt: '#ffa359',
    background: '#191d23',
    backgroundAlt: '#000000',
    surface: '#262c35',
    surfaceAlt: '#111419',
    secondary: '#3e4751',
    secondaryAlt: '#5A616A',
    contrastHigh: '#ffffff',
    contrastLow: '#c6d1db',
    contrastInvert: '#000000',
    code: {
      accent1: '#ff9ae1',
      accent2: '#9affa6',
      accent3: '#8ee8ff',
      accent4: '#c6d1db',
      accent5: '#c792ea',
      accent6: '#ffa359',
      accent7: '#9affe1',
      accent8: '#f2ff00',
      accent9: '#ff5959',
    },
    dataVis: {
      accent1: '#5188ff',
      accent2: '#7dedff',
      accent3: '#ff5469',
      accent4: '#a76fff',
      accent5: '#ff5bd4',
      accent6: '#ed2d22',
      accent7: '#ffac4a',
      accent8: '#8aff6d',
      accent9: '#77869b',
      accent10: '#e0edff',
    },
  },
};
